import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useToast } from "hooks/toast";
import { colors } from "../../global/globalStyle";

interface IDetailModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

export const DetailModal: React.FC<IDetailModalProps> = ({
  open,
  onClose,
  title,
  content,
}) => {
  const { addToast } = useToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    addToast({
      type: "success",
      title: "Copiado!",
      description: "Conteúdo copiado para a área de transferência.",
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          maxHeight: "80vh",
          maxWidth: "500px"
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography fontSize={20} fontWeight={700} component="span">
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon sx={{ color: colors.general_icons }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ marginTop: "20px" }}>
           <Box
          sx={{
            fontSize: "14px",
            lineHeight: "1.6",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
            maxHeight: "50vh",
            overflow: "auto",
          }}
        >
          {content}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
